// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var ReactIO = require("../../../shared/src/ReactIO.bs.js");
var WebStore = require("../store/WebStore.bs.js");
var Relude_IO = require("relude/src/Relude_IO.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var WebStore_Types_Action = require("../store/WebStore_Types_Action.bs.js");
var BrowserComponents_Loading = require("../../../shared-browser/src/components/BrowserComponents_Loading.bs.js");

function WebContainers_Logout$Presentation(Props) {
  var logout = Props.logout;
  ReactIO.useHandledIOOnMount(undefined)(logout);
  return React.createElement(BrowserComponents_Loading.$$Screen.make, {});
}

var Presentation = {
  make: WebContainers_Logout$Presentation
};

function mapStateToProps(prim) {
  
}

function mapDispatchToProps(dispatch) {
  var partial_arg = {
    logout: Curry._2(Relude_IO.mapError, (function (prim) {
            
          }), Curry._1(dispatch, WebStore_Types_Action.logout))
  };
  return function (param) {
    return Relude_Globals.$$const(partial_arg, param);
  };
}

function WebContainers_Logout(Props) {
  return React.createElement(WebStore.Provider.make, {
              mapStateToProps: mapStateToProps,
              mapDispatchToProps: mapDispatchToProps,
              children: (function (param, param$1) {
                  return React.createElement(WebContainers_Logout$Presentation, {
                              logout: param$1.logout
                            });
                })
            });
}

var make = WebContainers_Logout;

exports.Presentation = Presentation;
exports.mapStateToProps = mapStateToProps;
exports.mapDispatchToProps = mapDispatchToProps;
exports.make = make;
/* react Not a pure module */
